module.exports = __webpack_public_path__ + "files/084d3654b746be58c4ead97c26d16be2.png";